<template>
  <div
    v-if="!isEmpty"
    class="coupon-item"
    :class="{ active: active, invalid: invalid }"
    :pointValue="
      fullReductType ? fullReductMoney + currency : discount + '%OFF'
    "
    @click="updateActiveCouponId"
  >
    <div class="coupon-item-shade" v-show="active"></div>
    <div class="coupon-item-choose-ico" v-show="active"></div>
    <p class="coupon-item-name" v-if="fullReductType">
      {{ fullReductMoney }}
      <span class="coupon-item-currency">{{ currency }}</span>
    </p>
    <p class="coupon-item-name" v-else>{{ discount }}%OFF</p>
    <p class="coupon-item-tag">{{ tagText }}</p>
    <p class="coupon-item-type" v-if="fullReductLimitBottomMoney === 0">
      {{ letter.couponNoLimit }}
    </p>
    <p class="coupon-item-type" v-if="fullReductLimitBottomMoney > 0">
      {{
        letter.couponFuilCanUse
          .replace('${price}', fullReductLimitBottomMoney)
          .replace('${currency}', currency)
      }}
    </p>
    <p class="coupon-item-date">
      {{ letter.couponInvalidTime }}： {{ localEndDate }}
    </p>
    <p class="coupon-item-line"></p>
    <p class="coupon-item-tip">{{ useLimitTip }}</p>
    <p class="coupon-item-tip" v-if="discountType && discountLimitTopMoney">
      ({{
        letter.couponMaxDiscount
          .replace('${price}', discountLimitTopMoney)
          .replace('${currency}', currency)
      }})
    </p>
    <p class="coupon-item-tip" v-if="hasUsed">
      {{ letter.couponHasUsed }}：{{ localUsedDate }}
    </p>
  </div>
  <div class="coupon-item empty" :class="{ invalid: invalid }" v-else>
    <div class="coupon-item-empty-ico"></div>
    <p class="coupon-item-empty-text">{{ letter.couponHasNoCoupon }}</p>
  </div>
</template>

<script>
  import { times } from '../utiles/index'

  const letter = {
    couponNoLimit: '使用制限なし',
    couponFuilCanUse: '\${price} \${currency} 以上購入でご利用いただけます',
    couponInvalidTime: '有効期限',
    couponMaxDiscount: '最大\${price} \${currency} 引き',
    couponHasUsed: '使用済',
    couponUseNow: '今すぐ使う',
    couponHasNoCoupon: 'なし',
    couponOnlyCoinCanUse: 'ゲーム内通貨商品にのみ適用',
    couponOnlyPackageCanUse: 'パック商品にのみ適用',
    couponOnlySubCanUse: '月額購入商品にのみ適用',
    couponOnlyDaibiCanUse: 'トークン商品にのみ適用',
    couponPartProductCanUse: '一部商品対象',
    couponPartPaytypeCanUse: '一部の支払い方法にのみ適用',
    couponAllProductCanUse: '全商品対象',
    couponReductionType: '条件付き値引券',
    couponDiscountType: '割引券',
  }

  export default {
    name: 'couponItem',
    props: ['info', 'active', 'invalid', 'isEmpty'],
    data() {
      return {
        letter,
      }
    },
    computed: {
      fullReductType() {
        return +this.info.TYPE === 0
      },
      discountType() {
        return +this.info.TYPE === 1
      },
      startDate() {
        return this.dateFormat(this.info.START_TIME)
      },
      endDate() {
        return this.dateFormat(this.info.EXPIRY_TIME)
      },
      localStartDate() {
        return this.localFormatTime(this.info.START_TIME)
      },
      localEndDate() {
        return this.localFormatTime(this.info.EXPIRY_TIME)
      },
      localUsedDate() {
        return this.localFormatTime(this.info.USE_TIME)
      },
      currency() {
        return this.info.CURRENCY || ''
      },
      fullReductLimitBottomMoney() {
        return +this.info.LIMIT_BOTTOM_MONEY || 0
      },
      fullReductMoney() {
        return this.info.REDUCTION_MONEY || 0
      },
      discount() {
        return times(+this.info.DISCOUNT, 100)
      },
      discountLimitTopMoney() {
        return +this.info.LIMIT_TOP_MONEY
      },
      useLimitTip() {
        let tips = []
        const productType = {
          coin: letter.couponOnlyCoinCanUse,
          package: letter.couponOnlyPackageCanUse,
          subscription: letter.couponOnlySubCanUse,
          currency: letter.couponOnlyDaibiCanUse,
        }
        const hasPaytypeList =
          (this.info.PAY_TYPE_LIST && this.info.PAY_TYPE_LIST.length) || 0
        const hasProductList =
          (this.info.PRODUCT_LIST && this.info.PRODUCT_LIST.length) || 0
        const hasProductType = this.info.PRODUCT_TYPE || 0

        if (hasProductType) {
          tips.push(productType[this.info.PRODUCT_TYPE])
        }

        if (hasPaytypeList && hasProductList) {
          tips.push(letter.couponPartProductCanUse)
          tips.push(letter.couponPartPaytypeCanUse)
        } else if (hasPaytypeList && !hasProductList) {
          tips.push(letter.couponPartPaytypeCanUse)
        } else if (!hasPaytypeList && hasProductList) {
          tips.push(letter.couponPartProductCanUse)
        } else if (!hasPaytypeList && !hasProductList && !hasProductType) {
          tips.push(letter.couponAllProductCanUse)
        }

        return tips.join(';')
      },
      tagText() {
        if (this.info.DESCRIPTION) {
          return this.info.DESCRIPTION
        }
        if (this.fullReductType) {
          return letter.couponReductionType
        }
        if (this.discountType) {
          return letter.couponDiscountType
        }
        return ''
      },
      hasUsed() {
        // -1 提单未支付 0 未使用 1 完成支付 2 回收
        return +this.info.STATE === 1 || +this.info.STATE === -1
      },
    },
    methods: {
      // timestamp : 时间戳，单位为秒
      localFormatTime(timestamp) {
        return new Date(+timestamp * 1000).toLocaleString('ja-JP', {
          hour12: false,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        })
      },
      dateFormat(time) {
        const t = new Date(+time * 1000)
        const formate = 'Y-M-D h:m'
        let year = t.getFullYear()
        let month = t.getMonth() + 1
        let day = t.getDate()
        let hour = t.getHours()
        let minu = t.getMinutes()
        month = month > 9 ? month : `0${month}`
        day = day > 9 ? day : `0${day}`
        minu = minu == 0 ? '00' : minu
        const hash = {
          Y: year,
          M: month,
          D: day,
          h: hour,
          m: minu,
        }
        return formate.replace(/\w/g, (i) => {
          return hash[i]
        })
      },
      updateActiveCouponId() {
        this.$emit('chooseCoupon', this.info)
      },
    },
  }
</script>

<style scoped lang="scss">
  .coupon-item {
    --coupon-popup-item-name: #90352b;
    --coupon-popup-item-tag: #fffceb;
    --coupon-popup-item-type: #fffceb;
    --coupon-popup-item-date: #fffceb;
    --coupon-popup-item-line: #fffceb;
    --coupon-popup-item-tip: #fffceb;
    --coupon-popup-item-empty: #64563c;
    --coupon-popup-item-invalid-name: #555;
    --coupon-popup-item-invalid-tag: #f6f6f6;
    --coupon-popup-item-invalid-type: #f6f6f6;
    --coupon-popup-item-invalid-date: #f6f6f6;
    --coupon-popup-item-invalid-line: #e6e6e2;
    --coupon-popup-item-invalid-tip: #f6f6f6;
    --coupon-popup-item-empty: #64563c;

    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 10vh;
    padding: 30vh 32vh;
    width: 100%;
    height: 309vh;
    font-size: 10vh;
    background-size: 100% 100%;
    text-align: left;
    background: url('../assets/image/coupon-item-valid-bg.png') no-repeat
      center/contain;
    cursor: pointer;
    &-choose-ico {
      position: absolute;
      right: 0;
      top: 0;
      width: 84vh;
      height: 87vh;
      background: url('../assets/image/coupon-item-choose-ico.png') no-repeat
        center/contain;
    }
    &-name {
      margin: 0;
      font-size: 40vh;
      color: var(--coupon-popup-item-name);
    }
    &-tag {
      margin: 14vh 0 8vh;
      font-size: 20vh;
      color: var(--coupon-popup-item-tag);
    }
    &-type {
      margin: 0 0 8vh;
      font-size: 20vh;
      color: var(--coupon-popup-item-type);
    }
    &-date {
      color: var(--coupon-popup-item-date);
    }
    &-line {
      margin: 14vh auto;
      width: 100%;
      height: 1vh;
      background-color: var(--coupon-popup-item-line);
    }
    &-tip {
      margin-bottom: 10vh;
      font-size: 12vh;
      color: var(--coupon-popup-item-tip);
    }
    &-empty-ico {
      font-size: 0;
      width: 97vh;
      height: 97vh;
      background: url('../assets/image/coupon-popup-item-empty.png') no-repeat
        center/contain;
    }
    &-empty-text {
      margin-top: 30vh;
      font-weight: bold;
      font-size: 20vh;
      color: var(--coupon-popup-item-empty);
    }
    &-shade {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      transform: translate(-50%, -50%);
      background: url('../assets/image/coupon-item-shade.png') no-repeat
        center/contain;
    }
    &.invalid {
      position: relative;
      background: url('../assets/image/coupon-item-invalid-bg.png') no-repeat
        center/contain;
      .coupon-item-name {
        color: var(--coupon-popup-item-invalid-name);
      }
      .coupon-item-date {
        color: var(--coupon-popup-item-invalid-date);
      }
      .coupon-item-type {
        color: var(--coupon-popup-item-invalid-type);
      }
      .coupon-item-tip {
        color: var(--coupon-popup-item-invalid-tip);
      }
      .coupon-item-line {
        background: var(--coupon-popup-item-invalid-line);
      }
      .coupon-item-tag {
        color: var(--coupon-popup-item-invalid-tag);
      }
      .coupon-item-use {
        display: none;
      }
    }
    &.empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 309vh;
      background: url('../assets/image/coupon-item-valid-bg.png') no-repeat
        center/contain;
      &.invalid {
        .coupon-item-empty-text {
          font-weight: bold;
          font-size: 20vh;
          color: var(--coupon-popup-item-empty);
        }
      }
    }
  }
</style>
